interface CustomWindow extends Window {
    dataLayer: any;
}
declare let window: CustomWindow;

export function recordGaEvent(eventName: string, category: string, actionName: string, label: string, uniqueEventId: number) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            category: category,
            action: actionName,
            label: label,
            value: 1,
            "gtm.uniqueEventId": uniqueEventId
        });
    } catch (error) { console.log(error) }
}



// push_to_dataLayer({
//     event: "open chat",
//     category: "user engagement",
//     action: "chatopening",
//     label: "{{username}}",
//     value: 1
// gtm.uniqueEventId: איזה מספר שתבחרו
// })